import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const KeyIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    viewBox: "0 0 21.707 21.879",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 21.879),
    ...svgProps,
    fill: svgProps.fill ?? "none",
    stroke: color ?? svgProps.stroke ?? "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.5",
    children: [/*#__PURE__*/jsx("path", {
      d: "m11.704 13.148 2.26-2.23 1.566.418a1.412 1.412 0 0 0 1.673-1.742l-.418-1.555.73-.675 1.561.417a1.419 1.419 0 0 0 1.682-1.733l-.418-1.555a2.094 2.094 0 0 0-2.964-2.959l-8.634 8.655a5.586 5.586 0 1 0 2.963 2.959z"
    }), /*#__PURE__*/jsx("ellipse", {
      cx: "5.778",
      cy: "16.106",
      rx: "1.69",
      ry: "1.688"
    })]
  });
};

export { KeyIcon };
//# sourceMappingURL=key.js.map
